import { appConfig } from "../config/appConfig";

export const apiPost = async <TResponse = unknown>(
  url: string,
  body: unknown,
  options?: {
    signal?: AbortSignal;
    credentials?: RequestCredentials;
  }
): Promise<TResponse> => {
  if (!appConfig.apiBaseUrl) {
    throw new Error("API base URL is not configured.");
  }

  const response = await fetch(
    `${appConfig.apiBaseUrl}${url}`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify(body),
      signal: options?.signal,
      credentials: options?.credentials ?? "include" // useful if using cookies
    }
  );

  const contentType = response.headers.get("content-type");

  let responseBody: any = null;

  if (contentType?.includes("application/json")) {
    responseBody = await response.json();
  } else {
    responseBody = await response.text();
  }

  if (!response.ok) {
    throw new Error(
      responseBody?.message ||
      responseBody ||
      "API request failed"
    );
  }

  return responseBody as TResponse;
};